import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const getSentEmails = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/emailCampaigns/emails`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const getScheduledEmails = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/emailCampaigns/emails/scheduled`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const getDraftEmails = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/emailCampaigns/emails/draft`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const deleteEmail = async (uuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.delete(`${API_URL}/company/emailCampaigns/emails/${uuid}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const updateEmail = async (uuid, payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/emailCampaigns/emails/${uuid}`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const duplicateEmail = async (uuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/emailCampaigns/emails/duplicate/${uuid}`, {}, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const sendTest = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/emailCampaigns/emails/test`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const requestProUpdate = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/emailCampaigns/renew`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const cancelEmailDowngrade = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/emailCampaigns/cancel`, {}, {
        headers: {
            Authorization: "Bearer " + token
        }
    });

    return response.data;
};
